import { Grid, Box, Typography, TextField, Button } from "@material-ui/core";
import { WHITE, GREEN_PRIMRY, BLUE_PRIMARY, ERROR_COLOR } from "../utils/const";
import { Autocomplete } from "@material-ui/lab";
import { useHistory } from "react-router";
import useCustomState from "../hooks/State";
import Call from "../service/API";
import SuccessModal from "../components/generalModals/SuccessModal";
import Loading from "../components/loading";
import { useMountAPI } from "../hooks/APICall";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import moment from "jalali-moment";
import InfoIcon from "@material-ui/icons/Info";
import { Link } from "react-router-dom";
import DeleteIcon from "@material-ui/icons/Delete";
import DeletePermissionModal from "../components/deletePermissionModal";
import { useDispatch, useSelector } from "react-redux";
import { UpdateAccessTable } from "../store/actions";
import { useEffect } from "react";

const EditAdmin = (props) => {
  const updateCommands = useSelector((state) => state.updateCommands);

  const adminId = props.match.params.adminId;

  const isLoading = useCustomState(true);
  const adminInfo = useCustomState({});

  const accessIsLoading = useCustomState(true);
  const accessInfo = useCustomState({});

  const projectsIsLoading = useCustomState(true);
  const projects = useCustomState([]);

  const selectedProject = useCustomState({ name: "", id: null });
  const selectedProjectError = useCustomState({ error: false, text: "" });

  const deletedProject = useCustomState({ name: "", id: null });

  const projectChanged = (e, newValue) => {
    selectedProjectError.handleChange({ error: false, text: "" });
    selectedProject.handleChange(newValue);
  };

  const dispatch = useDispatch();

  const adminUtils = {
    isLoading: isLoading,
    adminInfo: adminInfo,
    adminId: adminId,
  };

  const accessUtils = {
    isLoading: accessIsLoading,
    info: accessInfo,
    adminId: adminId,
    dispatch: dispatch,
  };

  const projectsUtils = {
    page: 1,
    count: 100000,
    projectNameFilter: "",
    projectCreateDateFilter: "",
    isLoading: projectsIsLoading,
    projects: projects,
  };

  useMountAPI(fetchAdminInfo, adminUtils);
  useMountAPI(fetchAccessInfo, accessUtils);
  useMountAPI(fetchProjects, projectsUtils);

  useEffect(() => {
    if (updateCommands.updateAccessTable) {
      accessIsLoading.handleChange(true);
      fetchAccessInfo(accessUtils);
    }
  }, [updateCommands.updateAccessTable]);

  const successModalOpen = useCustomState(false);
  const successTitle = useCustomState("");
  const successMessage = useCustomState("دسترسی با موفقیت افزوده شد.");

  const permissionModalOpen = useCustomState(false);

  const openSuccessModal = () => {
    successModalOpen.handleChange(true);
  };

  const openPermissionModal = () => {
    permissionModalOpen.handleChange(true);
  };

  const closePermissionModal = () => {
    permissionModalOpen.handleChange(false);
  };

  const history = useHistory();

  const goToAdminList = () => {
    history.push("/admin/accessability");
  };

  const getCurrentProjects = (exclude = null) => {
    const projects = [];
    accessInfo.value.projects.map((p) => {
      if (p.id !== exclude) {
        projects.push(p.id);
      }
    });
    return projects;
  };

  const handleCancelPermission = () => {
    const projects = getCurrentProjects(deletedProject.value.id);
    const data = {
      middle_admin_id: adminId,
      project_ids: projects,
      water_meter_ids: [],
    };

    Call("POST", "middle/admin/add/data", data).then((response) => {
      if (response.data.code === 200) {
        dispatch(UpdateAccessTable({ updateAccessTable: true }));
        closePermissionModal();
        deletedProject.handleChange({ name: "", id: null });
      }
    });
  };

  const deleteAccess = (e) => {
    const projectId = e.currentTarget.id;
    const project = projects.value.filter((p) => p.id === projectId);
    if (project.length === 0) {
      return;
    } else {
      deletedProject.handleChange(project[0]);
      openPermissionModal();
    }
  };

  const addPermission = () => {
    let hasError = false;

    const project = selectedProject.value;
    if (!project.id) {
      selectedProjectError.handleChange({
        error: true,
        text: "انتخاب پروژه برای افزودن دسترسی الزامی است.",
      });
      hasError = true;
    }

    if (hasError) {
      return;
    }

    const projects = getCurrentProjects();
    projects.push(selectedProject.value.id);

    const data = {
      middle_admin_id: adminId,
      project_ids: projects,
      water_meter_ids: [],
    };

    Call("POST", "middle/admin/add/data", data).then((response) => {
      if (response.data.code === 200) {
        dispatch(UpdateAccessTable({ updateAccessTable: true }));
        openSuccessModal();
      }
    });
  };

  const renderAdminInfo = () => {
    if (isLoading.value) {
      return null;
    } else {
      return (
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ marginBottom: "16px" }}
        >
          <Typography>
            <span style={{ color: ERROR_COLOR, fontWeight: "bold" }}>
              {adminInfo.value.name + " " + adminInfo.value.lastname + " "}
            </span>
            <span>در حال حاضر به پروژه های زیر دسترسی دارد: </span>
          </Typography>
        </Grid>
      );
    }
  };

  const renderAccessTables = () => {
    if (accessIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "180px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <>
          <TableContainer
            component={Paper}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
            }}
          >
            <Table sx={{ maxWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell align={"center"}>#</TableCell>
                  <TableCell align={"center"}>نام پروژه</TableCell>
                  <TableCell align={"center"}>محل انجام</TableCell>
                  <TableCell align={"center"}>تاریخ شروع</TableCell>
                  <TableCell align={"center"}>جزئیات</TableCell>
                  <TableCell align={"center"}>لغو دسترسی</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {accessInfo.value.projects.map((project, idx) => {
                  return (
                    <TableRow>
                      <TableCell align={"center"}>
                        {convertNumbers(idx + 1)}
                      </TableCell>
                      <TableCell align={"center"}>{project.name}</TableCell>
                      <TableCell align={"center"}>{project.location}</TableCell>
                      <TableCell align={"center"}>
                        {convertNumbers(
                          moment(project.startDate)
                            .locale("fa")
                            .format("YYYY/MM/DD")
                        )}
                      </TableCell>
                      <TableCell align={"center"}>
                        <Link to={"/admin/project-dash/" + project.id}>
                          <InfoIcon
                            style={{
                              cursor: "pointer",
                              color: BLUE_PRIMARY,
                            }}
                          />
                        </Link>
                      </TableCell>
                      <TableCell align={"center"}>
                        <div onClick={deleteAccess} id={project.id}>
                          <DeleteIcon
                            style={{ color: ERROR_COLOR, cursor: "pointer" }}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      );
    }
  };

  const renderCurrentAccesses = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "16px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>
              دسترسی های کنونی
            </Typography>
          </Box>
          {renderAdminInfo()}
          {renderAccessTables()}
        </Grid>
      </>
    );
  };

  const renderProjects = () => {
    if (projectsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "100px" }}>
          <Loading width={120} showText={true} />
        </div>
      );
    } else {
      return (
        <>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            style={{
              paddingRight: "5%",
              paddingLeft: "5%",
              marginTop: "16px",
              marginBottom: "16px",
            }}
          >
            <Autocomplete
              onChange={projectChanged}
              value={selectedProject.value}
              options={projects.value}
              getOptionLabel={(option) => option.name}
              renderInput={(params) => (
                <TextField
                  error={selectedProjectError.value.error}
                  helperText={selectedProjectError.value.text}
                  {...params}
                  label="پروژه"
                  variant="standard"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button
              onClick={addPermission}
              style={{
                backgroundColor: BLUE_PRIMARY,
                color: WHITE,
                marginRight: "5%",
                marginLeft: "5%",
                marginTop: "16px",
                marginBottom: "16px",
              }}
            >
              افزودن دسترسی
            </Button>
          </Grid>
        </>
      );
    }
  };

  const renderAddAccess = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "16px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>
              افزودن دسترسی
            </Typography>
          </Box>
          {renderProjects()}
        </Grid>
      </>
    );
  };

  return (
    <>
      <SuccessModal
        open={successModalOpen}
        title={successTitle.value}
        message={successMessage.value}
        style={{ successColor: GREEN_PRIMRY }}
      />
      <DeletePermissionModal
        open={permissionModalOpen}
        adminInfo={adminInfo.value}
        project={deletedProject.value}
        handleCancelPermission={handleCancelPermission}
      />
      <Grid
        container
        style={{
          marginTop: "64px",
          paddingTop: "16px",
          paddingBottom: "16px",
          paddingRight: "8px",
          paddingLeft: "8px",
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            backgroundColor: WHITE,
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "8px",
            position: "relative",
          }}
        >
          <Box
            style={{
              maxWidth: "250px",
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: "-60px",
              paddingRight: "36px",
              paddingLeft: "36px",
              paddingTop: "24px",
              paddingBottom: "24px",
              borderRadius: "12px",
              backgroundColor: GREEN_PRIMRY,
              color: WHITE,
              cursor: "pointer",
            }}
            textAlign={"center"}
          >
            <Typography style={{ fontWeight: "bold" }}>
              ویرایش دسترسی مدیر
            </Typography>
          </Box>
          <Grid container style={{ paddingTop: "48px", paddingBottom: "48px" }}>
            {renderCurrentAccesses()}
            {renderAddAccess()}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default EditAdmin;

const processAdminInfo = (admin) => {
  const processedInfo = {
    id: admin.admin_id,
    name: admin.admin_name,
    lastname: admin.admin_lastname,
    phoneNumber: admin.admin_phone,
    permissions: admin.admin_permissions,
    registeredAt: admin.admin_create_date,
    info: admin.other_information,
  };
  return processedInfo;
};

const fetchAdminInfo = (utils) => {
  const isLoading = utils.isLoading;
  const adminInfo = utils.adminInfo;
  const adminId = utils.adminId;

  const data = {
    other_admin_id: adminId,
  };

  Call("POST", "admins/admin/getOne", data).then((response) => {
    // console.log("admin Info: ", response);
    if (response.data.code === 200) {
      adminInfo.handleChange(processAdminInfo(response.data.data));
    }
    isLoading.handleChange(false);
  });
};

const processProjects = (projects) => {
  const processedProjects = [];
  if (!projects) {
    return processedProjects;
  } else {
    projects.map((p) => {
      const data = {
        contractNumber: p.water_meter_project_contract_number,
        files: p.water_meter_project_files,
        id: p.water_meter_project_id,
        name: p.water_meter_project_name,
        startDate: p.water_meter_project_start_date,
        location: p.water_meter_project_title,
      };
      processedProjects.push(data);
    });
    return processedProjects;
  }
};

const processAccessInfo = (info, adminId) => {
  const results = {};
  let adminInfo = info.filter((inf) => inf.admin_id === adminId);
  if (adminInfo.length === 0) {
    return results;
  } else {
    adminInfo = adminInfo[0];
    results.id = adminInfo.admin_id;
    results.name = adminInfo.admin_name;
    results.phoneNumber = adminInfo.admin_phone;
    results.projects = processProjects(adminInfo.middle_admin_project_info);
  }
  return results;
};

const fetchAccessInfo = (utils) => {
  const isLoading = utils.isLoading;
  const info = utils.info;
  const adminId = utils.adminId;
  const dispatch = utils.dispatch;

  const data = {};

  Call("POST", "middle/admin/getAll", null).then((response) => {
    // console.log("middle admins: ", response);
    if (response.data.code === 200) {
      info.handleChange(processAccessInfo(response.data.data, adminId));
    }
    dispatch(UpdateAccessTable({ updateAccessTable: false }));
    isLoading.handleChange(false);
  });
};

const processProjectList = (projects) => {
  const results = [];
  let data, date;
  // console.log("projects", projects);
  projects.map((project) => {
    date = project.water_meter_project_start_date;
    data = {
      name: project.water_meter_project_name,
      user: "",
      location: project.water_meter_project_title,
      date: date,
      counters: project.water_meters_with_this_id.All_water_meter_with_this_id,
      id: project.water_meter_project_id,
    };
    results.push(data);
    // console.log(project.water_meter_project_create_date);
  });
  return results;
};

const fetchProjects = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const projectNameFilter = utils.projectNameFilter;
  const projectCreateDateFilter = utils.projectCreateDateFilter;
  const isLoading = utils.isLoading;
  const projects = utils.projects;
  const history = utils.history;

  const data = {
    page: page,
    count: count,
    water_meter_project_name: projectNameFilter,
    water_meter_project_create_date: projectCreateDateFilter,
  };
  Call("POST", "WaterMeterProjectsURL/admin/getAll", data)
    .then((response) => {
      // console.log("projects", response);
      if (response.data.code == 200) {
        const ps = response.data.data;
        projects.handleChange(processProjectList(ps));
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      // console.log(error);
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code === 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};
